// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Defines an API for attaching listeners to a event.
 */
export interface IEventListener<TFunction extends (...args: any[]) => any>
{
  addListener: (callback: TFunction) => void;
  removeListener: (listener: TFunction) => void;
  hasListener: (listener: TFunction) => boolean;
}